import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const submitMagicid = async (magicid = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!magicid) {
        console.log("no magicid");
        return null;
    }
    console.log("CALLING SERVER with submitconvertmagictofevir")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'submitconvertmagictofevir',
            'apiToken': apiToken,
            'magicId': magicid || ""
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from submitconvertmagictofevir call");
    }).catch((error) => { console.log(error); });
};

export default submitMagicid;